
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Add console logs to help debug GitHub Pages issues
console.log('Application initializing, base URL:', document.baseURI);
console.log('Window location:', window.location.toString());
console.log('Current script:', document.currentScript instanceof HTMLScriptElement ? document.currentScript.src : 'Unknown');
console.log('Environment:', import.meta.env.MODE);
console.log('Base URL from import.meta:', import.meta.env.BASE_URL);
console.log('Document base tag:', document.querySelector('base')?.href);
console.log('All script tags:', Array.from(document.querySelectorAll('script')).map(s => s instanceof HTMLScriptElement ? s.src : 'Non-HTML script'));

const rootElement = document.getElementById("root");
if (rootElement) {
  createRoot(rootElement).render(<App />);
} else {
  console.error("Root element not found!");
}
